import React from "react";

import styles from './styles/XSeek.module.scss';
// import { XTable, XTableRow, XTableCell } from "./XTable";
// import { XVStack } from "./XVStack";
// import { XHStack } from "./XHStack";
export interface ISeekProps {
    class?: string | null;
    //name:string;
    //optionalParam?:number;
}
export interface ISeekState {

}

export class XSeek extends React.Component<ISeekProps, ISeekState> {
    render() : React.ReactNode
    {//{React.Children.map(this.props.children, child => <div>{child}</div>)}
        const style = {
            marginLeft: '6px',
            marginRight: '42px',
            flexGrow: 1
        }
        return (
        <div className={styles.XSeek} style={style}>
            <input type="text" placeholder="Search"/>
            <div/>
            <button />
        </div>
        //&#128269;&#128270;        
        );
    }
}